export const CUSTOM_DRESS_STARTING_PRICE_USD = 650;
export const CUSTOM_DRESS_MAX_DISPLAY_PRICE_USD = 3250;

export const NON_BRIDAL_DRESS_MAX_QUOTE_USD = 1500;
export const BRIDAL_DRESS_MIN_QUOTE_USD = 1250;
export const BRIDAL_DRESS_MAX_QUOTE_USD = 3250;

export const CUSTOM_DRESS_PRICE_RANGE_LABEL = "$650-$3,250+";
export const PROM_FORMAL_PRICE_RANGE_LABEL = "$650-$1,500+";
export const BRIDAL_QUINCE_PRICE_RANGE_LABEL = "$1,250-$3,250+";
export const BOUTIQUE_PRICE_RANGE_LABEL = "$1,400-$5,300+";

export function normalizePublicDressPrice(
  amount: number | string | null | undefined
): number {
  const numericAmount =
    typeof amount === "string" ? Number.parseFloat(amount) : amount;

  if (typeof numericAmount !== "number" || !Number.isFinite(numericAmount)) {
    return CUSTOM_DRESS_STARTING_PRICE_USD;
  }

  return Math.max(CUSTOM_DRESS_STARTING_PRICE_USD, Math.round(numericAmount));
}

export function formatPublicDressPrice(
  amount: number | string | null | undefined,
  currency: string | null | undefined = "USD"
): string {
  return new Intl.NumberFormat("en-US", {
    style: "currency",
    currency: currency || "USD",
    minimumFractionDigits: 0,
    maximumFractionDigits: 0,
  }).format(normalizePublicDressPrice(amount));
}
